export module Downloader {
    export function download(name: string, data: any) {
        const blob = new Blob([data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
    }

    export function downloadBase64(name: string, data: string | number[]) {
        let bytes: Uint8Array;
        if (Array.isArray(data)) {
            // Kotlin ByteArray serialized as a JSON array of (possibly signed) byte values
            bytes = new Uint8Array(data.map(b => b & 0xFF));
        } else {
            const binary = atob(data);
            bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
        }
        download(name, bytes);
    }

}